import ContractForm from "./ContractForm";
import ContractPersonTypeToggle from "./ContractPersonTypeToggle";

// Entrada única de creación de contratos (/contracts/new): el selector define
// el tipo de persona. Natural (por defecto) monta el formulario actual sin
// cambios; Persona Jurídica navega al formulario del módulo jurídico
// (colección contractsLegal), que conserva el mismo selector para poder
// volver. El tipo no es modificable después de creado.

const ContractNew = () => (
  <>
    <ContractPersonTypeToggle value="NATURAL" />
    <ContractForm />
  </>
);

export default ContractNew;
